import { Injectable, OnInit } from '@angular/core';
import { PatientSession } from '@core/classes/other/patient-session';
import { PatientSearch } from '@core/classes/other/patient-search';
import { PatientData } from '@core/classes/other/patient-data';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PatientService {
  private storageSub= new Subject<PatientSession | undefined | null>();
  private _patient?: PatientSession;

  init(): void {
    if (sessionStorage.getItem('patient')) {
      this.patient = JSON.parse(sessionStorage.getItem('patient')!) as PatientSession;
    }
  }

  get pToken() {
    if (sessionStorage.getItem('patient')) {
      this.patient = JSON.parse(sessionStorage.getItem('patient')!) as PatientSession;
    }
    if (this._patient) {
      return this._patient.token;
    } else {
      return null;
    }
  }

  get data() {
    if (sessionStorage.getItem('patient')) {
      this.patient = JSON.parse(sessionStorage.getItem('patient')!) as PatientSession;
    }
    if (this._patient) {
      return this._patient.data;
    } else {
      return null;
    }
  }

  get version() {
    if (sessionStorage.getItem('patient')) {
      this.patient = JSON.parse(sessionStorage.getItem('patient')!) as PatientSession;
    }
    if (this._patient) {
      return this._patient.version;
    } else {
      return null;
    }
  }

  set patient(patient: PatientSession | undefined | null) {
    if (patient) {
      sessionStorage.setItem('patient', JSON.stringify(patient));
      this._patient = patient;
    } else {
      sessionStorage.removeItem('patient');
    }
    this.storageSub.next(patient);
  }

  get patient() {
    if (sessionStorage.getItem('patient')) {
      this.patient = JSON.parse(sessionStorage.getItem('patient')!) as PatientSession;
    }
    return this._patient;
  }

  get patientObservable() {
    return this.storageSub.asObservable();
  }

  // set data(data: PatientData) {
  //   if(this.patient) {
  //     this.patient.data = data;
  //   } else {
  //     this.patient = new PatientSession()
  //   }
  // }
}
